/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const ModalQueueService = require('./modalQueueService');
const ModalService = require('./modalService');
const StorageService = require('./storageService');
const UUIDService = require('./uuidService');
const UtilService = require('./utilService');
const addFormSubmitDirective = require('./addFormSubmitDirective');
const autofocusDirective = require('./autofocusDirective');
const closeOnClickOutsideDirective = require('./closeOnClickOutsideDirective');
const onEnterSpaceClickDirective = require('./onEnterSpaceClickDirective');
const onScrollIntoViewDirective = require('./onScrollIntoViewDirective');
const reamazeWidgetDirective = require('./reamazeDirective');
const scoreBadgeDirective = require('./scoreBadge/scoreBadgeDirective');

/**
 * Utility module for holding general common code between the main Enervee Angular applications.
 */
const commonModule = angular
    .module('enervee_utils.common', [])
    .factory('ModalQueueService', ModalQueueService)
    .factory('ModalService', ModalService)
    .factory('StorageService', StorageService)
    .factory('UUIDService', UUIDService)
    .factory('UtilService', UtilService)
    .directive('addFormSubmit', addFormSubmitDirective)
    .directive('enerveeAutofocus', autofocusDirective)
    .directive('closeOnClickOutside', closeOnClickOutsideDirective)
    .directive('onEnterSpaceClick', onEnterSpaceClickDirective)
    .directive('onScrollIntoView', onScrollIntoViewDirective)
    .directive('reamazeWidget', reamazeWidgetDirective)
    .directive('scoreBadge', scoreBadgeDirective);

module.exports = commonModule;